import React, { useState, useEffect } from "react";
import { PlansComparisonCredits } from "./Credits/PlansComparisonCredits";
import { RfModal } from "../RfModal/RfModal";
import { isCreditSystemEnabled } from "../../../routes/workspace/utils";
import { twClassNames } from "../../helpers/twClassNames";
import { useStore } from "zustand";
import { useGlobalStore } from "../../../../state/StoreContext";

function UpgradeModalTemplate({
    isModalOpen,
    closeModal,
    fsrc,
    excludePublic,
    successUrl,
    className = "",
    featureId,
    ...props
}) {
    const globalStore = useGlobalStore();
    const usage = useStore(globalStore, (state) => state.getUsage());
    const creditBased = isCreditSystemEnabled(usage);

    // if the user is already in the public plan but not in the credit system, we want to hide the public plan option
    // because it describes the public UBP plan, not the legacy public plan
    const isComingFromLegacyPublic = usage?.plan === "public" && !creditBased;
    const excludePublicFromOptions = excludePublic || isComingFromLegacyPublic;

    return (
        <RfModal
            isOpen={isModalOpen}
            onClose={closeModal}
            {...props}
            className={twClassNames("upgradeModal", className)}
        >
            <RfModal.Overlay />
            <RfModal.Panel
                fullscreen={true}
                className="bg-opacity-10 bg-gradient-to-b from-white to-purple-50"
            >
                <RfModal.CloseButton className="right-7 top-7" />
                <PlansComparisonCredits
                    fsrc={fsrc}
                    excludePublic={excludePublicFromOptions}
                    closeModal={closeModal}
                    successUrl={successUrl}
                    featureId={featureId}
                />
            </RfModal.Panel>
        </RfModal>
    );
}

export function UpgradeModal({
    isModalOpen,
    closeModal,
    fsrc,
    excludePublic = false,
    featureId,
    ...props
}) {
    return (
        <UpgradeModalTemplate
            isModalOpen={isModalOpen}
            closeModal={closeModal}
            fsrc={fsrc}
            excludePublic={excludePublic}
            featureId={featureId}
            {...props}
        />
    );
}

export function WorkspacePlansModal({ isModalOpen, closeModal, fsrc, ...props }) {
    return (
        <UpgradeModal
            isModalOpen={isModalOpen}
            closeModal={closeModal}
            excludePublic={true}
            fsrc={fsrc}
            {...props}
        />
    );
}

export function WorkspacePlansModalWithAutoUnmount({
    isModalOpen = true,
    fsrc,
    forwardedRef,
    excludePublic = false
}) {
    const [isOpen, setIsOpen] = useState(isModalOpen);
    useEffect(() => {
        if (!isOpen) {
            forwardedRef?.current?.remove?.();
        }
    }, [isOpen]);
    if (!isOpen) {
        return null;
    }
    function closeModal() {
        setIsOpen(false);
    }

    return (
        <UpgradeModalTemplate
            isModalOpen={isModalOpen}
            closeModal={closeModal}
            fsrc={fsrc}
            excludePublic={excludePublic}
        />
    );
}
